import React, {FunctionComponent} from "react";
import {combineStatesComponentType} from "../../../join_contexts_HOC/types";
import {useParams} from "react-router-dom";

export function createParamsComponent(componentId: string): combineStatesComponentType {
    return (Component: FunctionComponent) => {
        return (ownProps: any) => {
            const ctx = useParams()
            const innerProps = {
                [componentId]: ctx,
            }
            return <Component {...ownProps} {...innerProps} />
        }
    }
}
